import { render, staticRenderFns } from "./NumericProduct.vue?vue&type=template&id=3ba4037a&"
import script from "./NumericProduct.vue?vue&type=script&lang=js&"
export * from "./NumericProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports